//ENTRY POINT FOR WEBPACK WHEN process.env.REACT_APP_SPLIT_CODE = true

import { createRoot } from "react-dom/client";
import { lazy } from 'react'
import index from './index.js'
import { Route, Routes, BrowserRouter } from "react-router-dom";

const { AllContextProvider, Scaffolding, Home} = index

//Code Splitting: bulk of site content separated from initial landing bundle to increase first page load speed
//magic comment to give chunk name, see https://devdocs.tlm.cloud/webpack~5/concepts/under-the-hood
const Infrastructure = lazy(() => import(
    /* webpackChunkName: "Infrastructure" */
    './Infrastructure'))

const root = createRoot(document.getElementById('root'))
root.render(
    <BrowserRouter>
        <Routes>
            <Route element={<AllContextProvider />}>
                <Route path="/" element={<Scaffolding />}>
                    <Route index element={<Home />} />
                    <Route path="/*" element={<Infrastructure />}></Route>
                    {/* ROUTES SPLIT INTO INFRASTRUCTURE BUNDLE */}
                    {/* <Route path='resume' element={<Resume />} />
                    <Route path='about' element={<About />} />
                    <Route path='projects' element={<Projects />} />
                    <Route path='blog' element={<Blog />} />
                    <Route path='contact' element={<Contact />} /> */}
                    {/* <Route path='*' element={<h1>404 NOT FOUND</h1>} /> */}
                </Route>
            </Route>
        </Routes>
    </BrowserRouter>
)

if (module.hot) {
    // console.log('accepting hot base module')
    module.hot.accept('./index.js')
    root.render(
        <BrowserRouter>
            <Routes>
                <Route element={<AllContextProvider />}>
                    <Route path="/" element={<Scaffolding />}>
                        <Route index element={<Home />} />
                        <Route path="/*" element={<Infrastructure />}></Route>
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}